/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable @next/next/no-img-element */
import React from 'react';
import Markdown from 'markdown-to-jsx';
import cn from 'classnames';
import s from './Jumbo.module.scss';

export type JumboSectionTypes = {
  id: number;
  title: string;
  subtitle: string;
  images: any;
  data: any;
  shortTitle: string;
};

export type JumboTypes = {
  id: number;
  heading: string;
  subheading: any;
  media: any;
  section: JumboSectionTypes[];
  shortHeading: string;
};

export function Jumbo({ data }: { data: JumboTypes[] }) {
  return (
    <div className={cn(s.root, 'cmn_container')}>
      {data.length > 0
        ? data.map((component) => (
            <div key={component.id} className={s.item}>
              {(component?.heading ||
                component?.subheading ||
                component?.media?.data) && (
                <div className={s.head}>
                  {component?.heading && (
                    <Markdown className={s.heading}>
                      {component?.heading}
                    </Markdown>
                  )}
                  {component?.subheading && (
                    <Markdown
                      className={cn(
                        'markdown_with_table markdown_with_list',
                        s.subheading
                      )}
                    >
                      {component?.subheading}
                    </Markdown>
                  )}
                  {component?.media?.data && (
                    <div className={s.media}>
                      <img
                        src={component.media?.data?.attributes?.url}
                        alt={component.media?.data?.attributes?.name}
                      />
                    </div>
                  )}
                </div>
              )}
              {component?.section?.length > 0 && (
                <>
                  {component?.section?.map((section) => (
                    <div key={section.id} className={s.section}>
                      {section?.title && (
                        <Markdown className={s.title}>
                          {section?.title}
                        </Markdown>
                      )}
                      {section?.subtitle && (
                        <Markdown
                          className={cn(
                            'markdown_with_table',
                            s.subtitle,
                            'markdown_with_list'
                          )}
                        >
                          {section?.subtitle}
                        </Markdown>
                      )}
                      {section?.images?.data?.length > 0 && (
                        <div className={s.media}>
                          {section?.images?.data.map((el) => (
                            <div key={el} className={s.item}>
                              {el?.attributes?.url && (
                                <img
                                  src={el?.attributes?.url}
                                  alt={el?.attributes?.name}
                                />
                              )}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
                </>
              )}
            </div>
          )) //@ts-ignore
        : data?.subheading && (
            <Markdown
              className={cn(
                'markdown_with_table',
                'markdown_with_list',
                'markdown_content'
              )}
            >
              {
                //@ts-ignore
                data?.subheading
              }
            </Markdown>
            //@ts-ignore
          )}
    </div>
  );
}
